import Http from '../utils/http'
import store from 'store/index'

export const update = (payload) => {
    return Http.put(`/profile`, payload)
        .then(response => {
            store.dispatch('saveProfile', response.data)
            return response.data
        })
}

export const passwordUpdate = (payload) => Http.put(`/profile/password`, payload)

export const preferencesUpdate = (payload) => {
    return Http.put(`/profile/preferences`, payload)
               .then(response => {
                   store.dispatch('savePreferences', response.data)
                   return response.data
               })
}



// WEBPACK FOOTER //
// ./src/services/profile.js